import type { ReactNode } from "react";

import type {
  WidgetAccentColor,
  WidgetGroupLinePosition,
} from "~/v3-poc/components/Widget";
import { Widget } from "~/v3-poc/components/Widget";

export interface WorkspaceWidgetPresentationProps {
  id: string;
  title: string;
  titleSymbol?: ReactNode;
  headerAccessory?: ReactNode;
  children: ReactNode;
  accentColor?: WidgetAccentColor;
  groupLinePosition: WidgetGroupLinePosition;
  onRemove: () => void;
}

export const WorkspaceWidgetPresentation = ({
  id,
  title,
  titleSymbol,
  headerAccessory,
  children,
  accentColor,
  groupLinePosition,
  onRemove,
}: WorkspaceWidgetPresentationProps) => (
  <Widget
    id={id}
    title={title}
    titleSymbol={titleSymbol}
    accentColor={accentColor}
    groupLinePosition={groupLinePosition}
    onRemove={onRemove}
    headerAccessory={headerAccessory}
  >
    {children}
  </Widget>
);
